import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
// import { Close } from '@mui/icons-material';
import {
  // AppBar,
  // Dialog,
  // Divider,
  Grid,
  // IconButton,
  // Toolbar,
  // Tooltip,
  // Typography,
  useMediaQuery,
  useTheme,
  // Fab
} from '@mui/material';
import { FC, useState } from 'react';
import useEventCalendar from './useEventCalendar';
import "../../../../../pages/calendar/calendar.scss";
import { CALERNDAR_TYPES } from 'constants/CalendarConstant';


interface Props {
  x?:number
  color?: string;
  i: number;
  content: ReactJSXElement;
  title?: string;
}

const Event: FC<Props> = ({x, color, i, content, title }) => {
  const [showDialog, setShowDialog] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const context = useEventCalendar().context;
/*
span{
    display: block;
    width: 13px;
    height: 13px;
    background-color: var(--main-color);
    border-radius: 50%;
    margin-inline-end: 8px;
    &.brwn{
        background-color: var(--second-color) ;
    }
    &.red{
        background-color: #761431;
    }
}*/
  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <div className="coll-item-headr">
        {/* {x==3?<span className="blue"></span>:x==2?<span className="red"></span>:<span className="brwn"></span>} */}
        <span className={`${x === CALERNDAR_TYPES.PUBLICATIONS ? 'blue' : x === CALERNDAR_TYPES.EVENTS ? 'red' : 'brwn'}`}></span>
      </div>
      {/*
      <Tooltip title={title}>
        <Fab 
        //size='small'
        aria-label="add"
        component='div'
          onClick={() =>
            context?.showEventPopup ? setShowDialog((prev) => !prev) : null
          }
        sx={{
          //marginY: '0.1rem',
          backgroundColor: color ?? theme.palette.primary.main,
          color: theme.palette.getContrastText(
            color ?? theme.palette.primary.main
          ),
          maxHeight: '20px',
          maxWidth: '35px',
          boxShadow: 'none',
          cursor: context?.showEventPopup ? 'pointer' : 'transparent',
          borderRadius: '100px',
        }}>
        </Fab>
        {/* <Typography
          variant='caption'
          component='div'
          onClick={() =>
            context?.showEventPopup ? setShowDialog((prev) => !prev) : null
          }
          sx={{
            marginY: '0.1rem',
            backgroundColor: color ?? theme.palette.primary.main,
            color: theme.palette.getContrastText(
              color ?? theme.palette.primary.main
            ),
            cursor: context?.showEventPopup ? 'pointer' : 'transparent',
            borderRadius: '5px',
          }}
        >
          {i + 1}
        </Typography> *//*}
      </Tooltip>*/}

      {/*}
      <Dialog
        fullScreen={fullScreen}
        open={showDialog}
        onClose={() => setShowDialog((prev) => !prev)}
      >
        <AppBar
          sx={{
            position: 'relative',
            backgroundColor: color,
            color: theme.palette.getContrastText(
              color ?? theme.palette.primary.main
            ),
          }}
        >
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={() => setShowDialog((prev) => !prev)}
              aria-label='close'
            >
              <Close />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
              {title}
            </Typography>
          </Toolbar>
        </AppBar>

        <Divider light />
        {content}
      </Dialog>*/}
    </Grid>
  );
};

export default Event;
